//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FormatPrice from '@/elements/price/format-price.vue'

import RbBaseWishlist from '@/elements/miniwishlist/base-wishlist.vue'
import { mapState } from 'vuex'
import wcs from '@/scripts/libs/wcs'
import { isProductStellaByProductType, replaceWrongSign } from '@/scripts/libs/products'
import { GIFT_CARD, REMIX } from '@/scripts/constants/pdp'
import { LIGHT_GRAY } from '@/scripts/constants/colours'
import { NAVIGATION__ACTION__WISHLIST } from '@/scripts/constants/css-classes'
import { WcsStoreId } from '@/scripts/libs/wcs/types/store-id'
import WCAG from '@/scripts/libs/wcag/wcag'
import { Url } from '@/scripts/libs/url'

export default {
  name: 'rb-wishlist',
  components: {
    FormatPrice,
  },
  extends: RbBaseWishlist,
  data: function () {
    return {
      compareWhislistView: wcs.getEndPoint('compareWhislistView'),
      twitterSocialWhislist: wcs.getEndPoint('twitterSocialWhislist'),
      pinterestSocialWhislist: wcs.getEndPoint('pinterestSocialWhislist'),
      facebookSocialWhislist: wcs.getEndPoint('facebookSocialWhislist'),
      weiboSocialWhislist: wcs.getEndPoint('weiboSocialWhislist'),
      doubanSocialWhislist: wcs.getEndPoint('doubanSocialWhislist'),
      youkuSocialWhislist: wcs.getEndPoint('youkuSocialWhislist'),
      weChatSocialWhislist: wcs.getEndPoint('weChatSocialWhislist'),
      greyBackgroundParameter: `bgc=%23${LIGHT_GRAY}`,
      GIFT_CARD,
      REMIX,
    }
  },
  computed: {
    ...mapState({
      wishListHeader: (state) => state.sidebar.wishlist.details.wishListHeader,
      lastWishlistItem: (state) => state.lastWishlistItem,
    }),
    totalCount() {
      return this.items.reduce((total) => total + 1, 0)
    },
    getMiniwishlistItemMobile() {
      const items = this.items.filter(
        (item, index, self) => index === self.findIndex((t) => t.catentryId === item.catentryId)
      )
      return items.filter((item) => item.catentryId === this.lastWishlistItem)
    },
    isCurrentStoreChina() {
      return this.storeConfig?.storeId === WcsStoreId.CHINA
    },
  },
  methods: {
    sanitizeUrl: replaceWrongSign,
    getDataDescription(name, UPC) {
      return `RB_${name}_${UPC}`
    },
    imgGreyBackground(image) {
      // TODO: use Image methods
      const newSrc = Url.addParamsToUrl(image, this.greyBackgroundParameter)
      return this.sanitizeUrl(newSrc)
    },
    isProductStella(productType) {
      return isProductStellaByProductType(productType)
    },
    isGiftCard(category) {
      return category === GIFT_CARD
    },
    exitWishlist(e) {
      if (WCAG.isEnterPressed(e)) {
        if (document.getElementsByClassName(NAVIGATION__ACTION__WISHLIST)[0]) {
          const wishlistButton = document.getElementsByClassName(NAVIGATION__ACTION__WISHLIST)[0]
            .firstElementChild
          wishlistButton.focus()
        }
      }
    },
  },
}
